import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { LoanInterestRates } from 'src/app/Models/loanintrestrate';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-loanintrestrate',
  templateUrl: './loanintrestrate.component.html',
  styleUrls: ['./loanintrestrate.component.css']
})
export class LoanintrestrateComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: LoanInterestRates;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - LoanInterestRates form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.TYPE_NAME == undefined || this.data.TYPE_NAME=="") {
      this.message.error("Please Enter Type Name" , "");
      isOk = false
    }
    if (this.data.INTEREST_RATE == undefined || this.data.INTEREST_RATE=="") {
      this.message.error("Please Enter Intrest Rate" , "");
      isOk = false
    }
    if (this.data.DURATION == undefined || this.data.DURATION=="") {
      this.message.error("Please Enter Duration" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No." , "");
      isOk = false
    }
    if(isOk){

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateLoanInterestRates(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("LoanInterestRates information updated Successfully...", "");

	this.logtext = 'Update & Close - LoanInterestRates form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - LoanInterestRates ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - LoanInterestRates form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - LoanInterestRates ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update loanInterestRates information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createLoanInterestRates(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("LoanInterestRates information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - LoanInterestRates form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - LoanInterestRates ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new LoanInterestRates();
	this.logtext = 'Save & New - LoanInterestRates form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - LoanInterestRates ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add loanInterestRates information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - LoanInterestRates form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - LoanInterestRates ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}